import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, switchMap, take, throwError } from 'rxjs';
import { LastContext } from '../models/User';
import { LogLevel, LogService } from '../services/log.service';
import { UserService } from '../services/user.service';
import { CustomHttpError } from '../utils/CustomHttpError';

export const TEMP_SITE_ID = '8395aadc-a4b2-471e-bc52-58792c247bb9';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly userService = inject(UserService);
  private readonly logService = inject(LogService);

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.url.endsWith('api/me') || req.url.includes('i18n') || req.url.includes('myprofile')) {
      return next.handle(req);
    }

    return this.userService.getContext().pipe(
      take(1),
      switchMap((context: LastContext) =>
        next.handle(this.getAuthReq(context, req)).pipe(
          catchError((err: HttpErrorResponse) => {
            const traceId = this.logService.getTraceId();

            this.logService.addLog({
              message: err.message,
              level: LogLevel.ERROR,
              traceId,
              stack: `HttpErrorResponse: status: ${err.status}, url: ${err.url}`
            });

            console.error(`HTTP error occurred. TraceId: ${traceId}`, err);
            return throwError(() => new CustomHttpError(err, traceId));
          })
        )
      )
    );
  }

  private getAuthReq(context: LastContext, req: HttpRequest<any>): HttpRequest<any> {
    return req.clone({
      headers: req.headers.set('BB-Site-Id', context.siteId).set('BB-Unit-Id', context.unitId)
    });
  }
}
